import * as pdfjsLib from 'pdfjs-dist';

// Set up the worker for pdfjs to use the unpkg CDN
// This avoids needing to manually copy the worker file in the build process
pdfjsLib.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

/**
 * Converts a PDF File object into an array of base64 image strings.
 * This completely replaces the need for the backend PDF conversion API.
 * 
 * @param {File} file - The PDF File object
 * @returns {Promise<Array<string>>} - Promise resolving to an array of base64 PNG strings
 */
export const convertPdfToImages = async (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();

        fileReader.onload = async function () {
            try {
                const typedarray = new Uint8Array(this.result);
                // Load the PDF document
                const pdf = await pdfjsLib.getDocument(typedarray).promise;
                const images = [];

                // Convert each page sequentially
                for (let i = 1; i <= pdf.numPages; i++) {
                    const page = await pdf.getPage(i);

                    // Scale 2.5 is roughly equivalent to high DPI rendering 
                    // This ensures the cropped images are high resolution
                    const viewport = page.getViewport({ scale: 2.5 });

                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    // Render page into the canvas context
                    await page.render({ canvasContext: context, viewport: viewport }).promise;

                    // Extract base64 image string
                    const dataUrl = canvas.toDataURL('image/png');
                    // Remove the "data:image/png;base64," prefix to maintain compatibility 
                    // with the existing components that expect raw base64 strings
                    const base64 = dataUrl.split(',')[1];
                    images.push(base64);
                }

                resolve(images);
            } catch (error) {
                console.error("Error converting PDF to images in browser:", error);
                reject(error);
            }
        };

        fileReader.onerror = (error) => {
            console.error("Error reading file:", error);
            reject(error);
        };

        fileReader.readAsArrayBuffer(file);
    });
};
